// Centralised API base URL — extracted so Jest (CommonJS) can mock it
// without choking on `import.meta`. Vite resolves the env at build time.
export const API_BASE_URL: string =
  (import.meta as unknown as { env: { VITE_API_URL?: string } }).env
    ?.VITE_API_URL ?? 'http://localhost:4000';
